import React, { useState } from 'react';
import GameHeader from '../other_components/GameHeader';
import WaterUsageChart from './graph_components/WaterUsageChart';
import { nextLabel } from '../gameFlow';

const TwoDoughnutsGraphs = ({
    pageData,
    gameStatus,
    onDecisionSelect,
    displayButton = true,
    endsGame = false,
    editMode = false,
    onEditScoreItem,
    onAddScoreItem,
}) => {
    const [legends, setLegends] = useState([]);

    const handleLegendUpdate = (index, legendData) => {
        setLegends((prevLegends) => {
            const updatedLegends = [...prevLegends];
            updatedLegends[index] = legendData;
            return updatedLegends;
        });
    };

    const handleNextClick = () => {
        const pageResult = {
          page_id: pageData._id,
          page_type: 'two_doughnuts_graphs',
          page_general_consequence: pageData.page_general_consequence,
        };
    
        onDecisionSelect(pageResult);
    };

    return (
        <div className="page-general-container">
            <div className='page-general-background-color'></div>
            <div className='page-general-background-hero' style={{ backgroundImage: `url(/img/bgrille-m.svg)` }}>
                <div className='page-general-background-image' style={{ backgroundImage: `url(${pageData.content.background_image_url})` }}></div>
            </div>

            <div className='page-main-content'>
                <GameHeader gameStatus={gameStatus} listScore={null} pageName={pageData.title}></GameHeader>

                <div className="two-doughnuts-graphs-charts">
                    {pageData.content.list_scores.map((score_to_plot, index) => {
                        const scoreData = gameStatus.score_dic[score_to_plot];
                        return (
                            <div key={index} className={`two-doughnuts-graphs-chart ${editMode ? 'builder-editable-card' : ''}`}>
                                {editMode && (
                                    <button
                                        className="builder-edit-fab builder-edit-fab-card"
                                        onClick={() => onEditScoreItem(index)}
                                        title="Changer le score affiché dans ce donut"
                                    >✏️</button>
                                )}
                                <WaterUsageChart
                                    data={scoreData.metadata.current}
                                    unit="m³"
                                    totalInitConsumption={scoreData.standard_value}
                                    showLegend={false}
                                    title={scoreData.name}
                                    onLegendUpdate={(legendData) => handleLegendUpdate(index, legendData)}
                                />
                            </div>
                        );
                    })}
                    {editMode && (
                        <div className="two-doughnuts-graphs-chart builder-add-card" onClick={onAddScoreItem} title="Ajouter un donut">
                            <span className="builder-add-card-plus">+</span>
                            <span>Ajouter un score</span>
                        </div>
                    )}
                </div>

                <div className="two-doughnuts-graphs-legends">
                    {legends.map((legend, index) => (
                        <div key={index} className="legend-items">
                            {legend.map((item, i) => (
                                <div key={i} className="legend-item">
                                    <span
                                        className="legend-color"
                                        style={{ backgroundColor: item.fillStyle }}
                                    ></span>
                                    <span className="legend-label">{item.text}</span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                {!editMode && displayButton && (
                    <button className='blue-button' onClick={handleNextClick}>{nextLabel(endsGame)}</button>
                )}
            </div>
        </div>
    );
};

export default TwoDoughnutsGraphs;